import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { CRYPTOCURRENCY_EDIT_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormDefaults";
import type { CryptocurrencyEditFormInput } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { mapInvestmentToolsToForm } from "web_myplann/Portfolio/Forms/InvestmentForm/Mappers/mapInvestmentToolsToForm";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const mapPortfolioToCryptocurrencyForm = (
	portfolio: PortfolioDetailResponseDTO,
	t: TranslateFunction,
): CryptocurrencyEditFormInput => ({
	name: portfolio.name ?? DEFAULTS.name,
	contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
	producer: portfolio.producer ?? DEFAULTS.producer,
	product: portfolio.product ?? DEFAULTS.product,
	signedAt: parseIsoDate(portfolio.signedAt),
	startAt: parseIsoDate(portfolio.startAt),
	endAt: parseIsoDate(portfolio.endAt),
	tools: mapInvestmentToolsToForm(portfolio.tools, t),
});
